
export const PLAY_SONG = 'player/PLAY_SONG';
export const PAUSE_SONG = 'player/PAUSE_SONG';
export const TOGGLE_PLAYING = 'player/TOGGLE_PLAYING';
export const SET_REPEAT = 'player/SET_REPEAT';
export const SHUFFLE = 'player/SHUFFLE';
export const MUTE = 'player/MUTE';

/**
 * Plays a song and queue a list of songs that
 * will play after each others
 * @param {Object} song 
 * @param {Array} queue
 */
export function play(song, queue) {
  let queueFinal = queue
  
  if (!queueFinal) {
    queueFinal = [song]
  }

  return {
    type: PLAY_SONG,
    payload: { song, queue: queueFinal },
  };
}

/**
 * Pauses the current song
 */
export function pause() {
  return {
    type: PAUSE_SONG,
  };
}

/**
 * Toggles the repeat
 */
export function setRepeat() {
  return (dispatch, getState) => {
    const state = getState();
    const values = ['none', 'all', 'one'];
    let index = values.indexOf(state.player.repeat) + 1;

    if (index >= values.length) {
      index = 0
    }

    dispatch({
      type: SET_REPEAT,
      payload: {
        repeat: values[index],
      }
    });
  }
}

/**
 * Plays/Pauses the current song
 */
export function togglePlaying() {
  return {
    type: TOGGLE_PLAYING,
  };
}

/**
 * Plays the next song in the queue, if the repeat is on, then
 * it plays the first song when reaching the end of the queue.
 * @param {Object} current song
 * @param {Array} queue 
 */
export function playNext(current, queue = []) {
  return (dispatch, getState) => {
    const state = getState()
    const index = queue.findIndex(sng => sng.id === current.id)
    const repeat = state.player.repeat;

    if (index > -1) {
      const nextIndex = index + 1;

      if (nextIndex < queue.length) {
        dispatch(play(queue[nextIndex], queue));
      } if (repeat === 'all' && nextIndex === queue.length) {
        dispatch(play(queue[0], queue));
      }
    }
  }
}

/**
 * Plays the previous song in the queue, if the repeat is on, then
 * it plays the last song when reaching the begining of the queue.
 * @param {Object} current song
 * @param {Array} queue
 */
export function playPrev(current, queue = []) {
  return (dispatch) => {
    const index = queue.findIndex(sng => sng.id === current.id)

    if (index > -1) {
      const prevIndex = index - 1;

      if (prevIndex > -1) {
        dispatch(play(queue[prevIndex], queue));
      }
    }
  }
}

/**
 * Shuffle songs in the current queue
 */
export function shuffle() {
  return (dispatch, getState) => {
    const state = getState();
    const queue = [...state.player.original];

    dispatch({
      type: SHUFFLE,
      payload: {
        queue: queue.sort(() => Math.random() - 0.5),
      }
    })
  }
}

/**
 * Shuffle songs in the current queue
 */
export function toggleMute() {
  return {
    type: MUTE,
  }
}
